import { SxProps, Theme } from "@mui/material";

export const flowMapDropdownStyles = {
    dropdownTrigger: {
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        padding: "0 8px",
        height: "24px",
        cursor: "pointer",
        borderRadius: "4px",
        transition: "background-color 0.2s",
        marginLeft: "-8px",
        "&:hover": {
            backgroundColor: "greyscale.200"
        }
    } as SxProps<Theme>,

    dropdownContent: {
        minWidth: "350px",
        width: "661px",
        display: "flex",
        flexDirection: "column",
        borderColor: "greyscale.200",
        borderTop: "none"
    } as SxProps<Theme>,

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        margin: 0,
        borderBottom: "1px solid",
        borderColor: "greyscale.200",
        backgroundColor: "background.paper",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        width: "661px",
    } as SxProps<Theme>,

    flowMapContainer: {
        height: "400px",
        width: "661px",
        position: "relative",
        backgroundColor: "background.paper",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
    } as SxProps<Theme>,

    deploymentInfo: {
        fontWeight: 400,
        color: "primary.700"
    } as SxProps<Theme>,

    appName: {
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "20vw",
        display: "inline-block",
        verticalAlign: "bottom",
        color: "primary.700"
    } as SxProps<Theme>,

    buttonContent: {
        display: "flex",
        alignItems: "center",
        gap: 1
    } as SxProps<Theme>,

    flowListContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        padding: "24px"
    } as SxProps<Theme>,

    flowNode: (isActive: boolean) => ({
        height: "46px",
        width: "147px",
        padding: "5px",
        backgroundColor: isActive ? "greyscale.200" : "background.paper",
        border: "1px solid",
        borderColor: isActive ? "greyscale.400" : "greyscale.300",
        borderRadius: "30px",
        cursor: "pointer",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s",
        "&:hover": {
            backgroundColor: isActive ? "greyscale.300" : "greyscale.50",
            borderColor: isActive ? "greyscale.400" : "greyscale.300"
        },
        "&:active": {
            backgroundColor: "greyscale.500",
            borderColor: "greyscale.600"
        }
    }) as SxProps<Theme>,

    nodeContainer: {
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%"
    } as SxProps<Theme>,

    flowIcon: {
        display: "inline-block",
        backgroundColor: "greyscale.100",
        borderRadius: "50%",
        padding: "5px",
        color: "greyscale.800",
        fontSize: "24px",
        lineHeight: "24px",
        width: "32px",
        height: "32px",
        textAlign: "center",
        "&::before": {
            marginLeft: "2px",
            marginRight: "-2px"
        }
    } as SxProps<Theme>,

    nodeName: {
        fontSize: "12px",
        color: "greyscale.900",
        margin: "auto 0",
        paddingLeft: "8px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        flex: 1
    } as SxProps<Theme>,

    emptyState: {
        padding: 2,
        textAlign: "center"
    } as SxProps<Theme>,

    dropdownWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 1
    } as SxProps<Theme>,

    arrowIcon: (isOpen: boolean) => ({
        transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
        transition: "transform 0.2s",
        fontSize: "14px",
        width: "14px",
        height: "14px"
    }) as SxProps<Theme>,

    dropdownPopover: {
        marginTop: "16px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        overflow: "visible",
        left: "175px !important"
    } as SxProps<Theme>
};

export const newSubflowDialogStyles = {
    content: {
        padding: "0",
        minHeight: "auto"
    } as SxProps<Theme>,

    wrapper: {
        ".MuiPaper-root": {
            width: "350px"
        }
    } as SxProps<Theme>
};
